"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddToWaitingListCommand = void 0;
const typia_1 = __importDefault(require("typia"));
exports.validateAddToWaitingListCommand = (() => { const $guard = typia_1.default.createAssert.guard; const $io0 = input => "string" === typeof input.email; const $ao0 = (input, _path, _exceptionable = true) => "string" === typeof input.email || $guard(_exceptionable, {
    path: _path + ".email",
    expected: "string",
    value: input.email
}, _errorFactory); const __is = input => "object" === typeof input && null !== input && $io0(input); let _errorFactory; return (input, errorFactory) => {
    if (false === __is(input)) {
        _errorFactory = errorFactory;
        ((input, _path, _exceptionable = true) => ("object" === typeof input && null !== input || $guard(true, {
            path: _path + "",
            expected: "AddToWaitingListCommand",
            value: input
        }, _errorFactory)) && $ao0(input, _path + "", true) || $guard(true, {
            path: _path + "",
            expected: "AddToWaitingListCommand",
            value: input
        }, _errorFactory))(input, "$input", true);
    }
    return input;
}; })();
